export default __webpack_public_path__ + "static/media/DisabledAccount.8f57c2ee.svg";